import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    pageNameChip: {
      marginBottom: 15,
      fontFamily: 'Texta Heavy',
      fontSize: 16,
      color: Colors.white,
      letterSpacing: '1px',
      backgroundColor: Colors.main,
      paddingLeft: 15,
      paddingRight: 15,
      borderRadius: '10px'
    },
    topPageNameChip: {
      position: 'absolute',
      zIndex: 1000,
      left: 70,
      top: 10,
      boxShadow: theme.shadows[1],
      [theme.breakpoints.down('sm')]: {
        display: "none"
      }
    },
    btnSelected: {
      backgroundColor: Colors.secundary,
      fontWeight: 'bold',
      color: '#404040',
    },
    popupLine: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    popupTitle: {
      color: Colors.secundary,
      fontVariant: 'small-caps',
      fontWeight: 'bold',
      fontSize: '12px',
      width: '100%',
    },
    popupContent: {
      alignSelf: 'center',
      fontWeight: 'bold',
      fontSize: '1rem',
    },
    actionButton: {
      display: "flex",
      justifyContent: "space-around",
      width: '100%',
    },
    linkExibir: {
      padding: '4px',

      fontFamily: 'Roboto',
      fontSize: '14px',
      width: '40%',
      border: 'transparent',
      backgroundColor: Colors.secundary,
      borderRadius: '0',
      textDecoration: 'none',
      color: '#404040',
    },
    linkEditar: {
      text: 'center',
      padding: '4px',
      fontFamily: 'Roboto',
      fontSize: '14px',
      width: '40%',
      border: `1px solid ${Colors.secundary}`,
      fontVariant: 'small-caps',
      borderRadius: '0',
      textDecoration: 'none',
      color: '#404040',
    }
  }),
);
